import { getHumanReadableNameCellHelper } from "../../../../../../../utils";

import type { Order, Language } from "../../../../../../../services";

const cellProcessing = (
	item: Order.Model["taxiService"],
	language: Language,
): string => getHumanReadableNameCellHelper(item?.company?.name, language);

export default cellProcessing;
